import {useState} from "../../../__snowpack__/pkg/react.js";
import {axios} from "../../lib/axios.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {encodeB64} from "../../lib/encoder.js";
import {axios as defaultAxios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useShopeeCategories = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (channel) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas//shop/get-categories`, {
        channel
      });
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    channelCategoriesLoading: loading,
    channelCategories: data,
    fetchChannelCategories: fetchData
  };
};
export const useShopeeCategoriesModel = createModel(useShopeeCategories);
export const useGetBrandsByChannel = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (param) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.get(`/saas/product-brand/channels/get-brands-by-channel`, {
        params: param
      });
      let newData = data2;
      if (!param.prefix) {
        newData = [
          {
            label: "0",
            value: "NoBrand"
          },
          ...data2.filter((uData) => {
            return uData.label != "0";
          })
        ];
      }
      setData(newData);
      return newData;
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    shopeeBrandsLoading: loading,
    shopeeBrands: data,
    fetchShopeeBrands: fetchData
  };
};
export const useGetBrandsByChannelModel = createModel(useGetBrandsByChannel);
export const getSaasShopLogisticsShop = () => {
  const [data, setData] = useState({});
  const [dataMap, setDataMap] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (shopIds, shopId) => {
    setLoading(true);
    try {
      if (shopIds && shopIds.length) {
        const {data: resultData} = await defaultAxios.get(`/saas/product/get-product-logistics-options`, {
          params: {shopId: shopIds}
        });
        let promiseMap = {};
        let promiseAllMap = {...dataMap};
        resultData.forEach((reData, reIndex) => {
          if (!promiseAllMap[shopIds[reIndex]]) {
            promiseAllMap[shopIds[reIndex]] = {};
          }
          promiseMap[reData.shopId] = reData.logisticsList.map((obj) => {
            promiseAllMap[shopIds[reIndex]][obj.name] = obj;
            return {
              label: obj.name,
              enabled: obj.enabled,
              value: obj.name
            };
          });
        });
        setData(promiseMap);
        setDataMap(promiseAllMap);
        return {
          blibliLogisticsLoading: loading,
          blibliLogistics: data,
          blibliLogisticsAll: dataMap,
          fetchShopeeLogistics: fetchData
        };
      } else if (shopId) {
        let defaultData = await defaultAxios.get(`/saas/product/get-product-logistics-options`, {
          params: {shopId}
        });
        let promiseMap = {};
        let promiseAllMap = {...dataMap};
        promiseAllMap[shopId] = defaultData.data;
        if (!promiseAllMap[shopId]) {
          promiseAllMap[shopId] = {};
        }
        promiseMap[shopId] = defaultData.data.map((obj) => {
          promiseAllMap[shopId][obj.name] = obj;
          return {
            label: obj.name,
            enabled: obj.enabled,
            value: obj.name
          };
        });
        setData(promiseMap);
        setDataMap(promiseAllMap);
        return {
          shopeeLogisticsLoading: loading,
          shopeeLogistics: data,
          blibliLogisticsMap: dataMap,
          fetchShopeeLogistics: fetchData
        };
      } else {
        setData({});
        setDataMap({});
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    shopeeLogisticsLoading: loading,
    shopeeLogistics: data,
    shopeeLogisticsMap: dataMap,
    fetchShopeeLogistics: fetchData
  };
};
export const getSaasShopLogisticsShopModel = createModel(getSaasShopLogisticsShop);
export const getWarehouseChannel = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [warehouseAllMap, setWarehouseAllMap] = useState({});
  const fetchData = async (shopIds, shopId) => {
    setLoading(true);
    try {
      let promiseAll = [];
      if (shopIds && shopIds.length) {
        let promiseMap = {};
        shopIds.forEach((data2) => {
          promiseAll.push(defaultAxios.post(`/saas/shop/get-shop-warehouse-by-channel-shop`, {
            shopId: data2,
            channel: "SHOPEE_ID"
          }));
        });
        const resultData = await Promise.all(promiseAll);
        let newWarehouseAllMap = {};
        resultData.forEach((reData, reIndex) => {
          promiseMap[shopIds[reIndex]] = reData.data;
          reData.data.map((obj) => {
            newWarehouseAllMap[obj.externalWareId] = !obj.geolocation;
            if (!obj.latitude && !obj.longitude) {
              newWarehouseAllMap[obj.externalWareId] = true;
            }
          });
        });
        setWarehouseAllMap(newWarehouseAllMap);
        setData(promiseMap);
        return {
          warehouseChannelLoading: loading,
          warehouseChannel: data,
          warehouseAllMap,
          fetchWarehouseChannel: fetchData
        };
      } else if (shopId) {
        let defaultData = await defaultAxios.post(`/saas/shop/get-shop-warehouse-by-channel-shop`, {
          shopId,
          channel: "SHOPEE_ID"
        });
        let promiseMap = {};
        let promiseAllMap = {};
        promiseAllMap[shopId] = defaultData.data;
        let newWarehouseAllMap = {};
        promiseMap[shopId] = defaultData.data.map((obj) => {
          newWarehouseAllMap[obj.externalWareId] = !obj.geolocation;
          if (!obj.latitude && !obj.longitude) {
            newWarehouseAllMap[obj.externalWareId] = true;
          }
          return obj;
        });
        setWarehouseAllMap(newWarehouseAllMap);
        setData({...data, ...promiseMap});
        return {
          warehouseChannelLoading: loading,
          warehouseChannel: data,
          warehouseAllMap,
          fetchWarehouseChannel: fetchData
        };
      } else {
        setData({});
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    warehouseChannelLoading: loading,
    warehouseChannel: data,
    warehouseAllMap,
    fetchWarehouseChannel: fetchData
  };
};
export const getWarehouseChannelModel = createModel(getWarehouseChannel);
export const pullShopWarehouse = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const {fetchWarehouseChannel} = getWarehouseChannelModel();
  const fetchData = async (params) => {
    setLoading(true);
    let {data: data2} = await defaultAxios.post(`/saas/shop/pull-shop-warehouse-by-channel-and-shop`, params);
    if (data2) {
      let fetchData2 = await fetchWarehouseChannel([], params.shopId);
      if (fetchData2) {
        setLoading(false);
      }
    }
    setData(data2);
  };
  return {
    pullShopWarehouseLoading: loading,
    pullShopWarehouse: data,
    fetchPullShopWarehouse: fetchData
  };
};
export const pullShopWarehouseModel = createModel(pullShopWarehouse);
export const pullLogistics = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const {fetchShopeeLogistics} = getSaasShopLogisticsShopModel();
  const fetchData = async (params) => {
    setLoading(true);
    let {data: data2} = await defaultAxios.post(`/saas/shop/pull-logistics-by-channel-and-shop`, params);
    if (data2) {
      let fetchData2 = await fetchShopeeLogistics([], params.shopId);
      if (fetchData2) {
        setLoading(false);
      }
    }
    setData(data2);
  };
  return {
    pullLogisticsLoading: loading,
    pullLogistics: data,
    fetchPullLogistics: fetchData
  };
};
export const pullLogisticsModel = createModel(pullLogistics);
export const getSaasProductShopCategories = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas/shop/get-categories`, params);
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    shopeeCategoriesLoading: loading,
    shopeeCategories: data,
    fetchShopeeCategories: fetchData
  };
};
export const getSaasProductShopCategoriesModel = createModel(getSaasProductShopCategories);
export const getCategoryAttributesChannel = () => {
  const [data, setData] = useState();
  const [mandatoryData, setMandatoryData] = useState([]);
  const [optionalData, setOptionalData] = useState([]);
  const [allAttributeIdMap, setAllAttributeIdMap] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas/shop/get-categoryAttributes-by-channel`, params);
      let newDataMap = {};
      let newDataMapName = {};
      data2.map((data3, index) => {
        newDataMap[data3.attributeId] = data3;
        newDataMapName[data3.attributeName] = data3;
      });
      let newData = [];
      let attributeIdMap = {};
      let toryData = [];
      let optionalData2 = [];
      data2.map((data3, index) => {
        if (data3.mandatory && !data3.variantCreating && !data3.specialAttribute) {
          toryData = [...toryData, data3];
        }
        if (!data3.mandatory && !data3.variantCreating && !data3.specialAttribute) {
          optionalData2 = [...optionalData2, data3];
        } else if (data3.attributeName === "Warna" && data3.variantCreating && newDataMap[data3.attributeId]) {
          newData = [...newData, data3];
          let newOptions = [];
          if (newDataMapName["Family Colour"] && newDataMapName["Family Colour"].options) {
            data3["type"] = "INPUT_SELECT";
            newOptions = newDataMapName["Family Colour"].options.map((oData) => {
              return {
                value: oData
              };
            });
          }
          data3["options"] = newOptions;
        } else if (data3.variantCreating) {
          newData = [...newData, data3];
        }
        attributeIdMap[data3.attributeId] = data3;
      });
      setData(newData);
      setMandatoryData(toryData);
      setOptionalData(optionalData2);
      setAllAttributeIdMap(attributeIdMap);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const resetData = () => {
    setData(void 0);
    setAllAttributeIdMap({});
    setMandatoryData([]);
  };
  return {
    categoriesAttributesLoading: loading,
    categoriesAttributes: data,
    resetCategoriesAttributes: resetData,
    mandatoryData,
    optionalData,
    allAttributeIdMap,
    fetchCategoriesAttributes: fetchData
  };
};
export const getCategoryAttributesChannelModel = createModel(getCategoryAttributesChannel);
export const saasProductCreateProduct = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas/product/create-product`, {
        params
      });
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    createProductLoading: loading,
    createProduct: data,
    fetchCreateProduct: fetchData
  };
};
export const saasProductCreateProductModel = createModel(saasProductCreateProduct);
export const useProductShopee = () => {
  const [data, setData] = useState(void 0);
  const [loading, setLoading] = useState(false);
  const fetchData = async (productId) => {
    setLoading(true);
    try {
      let param = {
        productId,
        channelId: "SHOPEE_ID"
      };
      let {data: data2} = await axios.post(`/saas/product/get-product`, {
        ...param
      });
      if (data2?.variantOptions && data2?.variations?.[0]?.optionIndexes?.length && !data2?.variations?.[0]?.nameB64) {
        data2.variations = data2?.variations.map((item) => {
          return {
            ...item,
            nameB64: `${encodeB64(data2?.variantOptions?.[0]?.values?.[item?.optionIndexes?.[0]])}${data2?.variantOptions?.[1]?.values ? "/" : ""}${data2?.variantOptions?.[1]?.values ? encodeB64(data2?.variantOptions?.[1]?.values?.[item?.optionIndexes?.[1]]) : ""}`
          };
        });
      }
      setData({...data2, shopIds: [data2?.shopId]});
      return {
        productInfo: data2.data
      };
    } catch (error) {
      handleError(error);
      return {
        productInfo: {}
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productInfoLoading: loading,
    productInfoMsg: data,
    fetchProductInfo: fetchData
  };
};
export const useProductShopeeModel = createModel(useProductShopee);
